var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33398 8.66667C1.33398 8.33333 1.66732 8 2.00065 8C2.33398 8 2.66732 8.33333 2.66732 8.66667C2.66732 9 2.66732 12 2.66732 12C2.66732 12.7364 3.26427 13.3333 4.00065 13.3333H12.0007C12.737 13.3333 13.334 12.7364 13.334 12V8.66667C13.334 8.29848 13.6325 8 14.0007 8C14.3688 8 14.6673 8.29848 14.6673 8.66667V12C14.6673 13.4728 13.4734 14.6667 12.0007 14.6667H4.00065C2.52789 14.6667 1.33398 13.4728 1.33398 12C1.33398 12 1.33398 9 1.33398 8.66667Z",
    fill: "#3787FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 7.33398,
    y: 1.3335,
    width: 1.33333,
    height: 9.33333,
    rx: 0.666667,
    fill: "#3787FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02416 2.25182L5.13807 5.13791C4.87772 5.39826 4.45561 5.39826 4.19526 5.13791C3.93491 4.87756 3.93491 4.45545 4.19526 4.1951L7.5286 0.861767C7.77932 0.611046 8.18242 0.600445 8.44598 0.837642L11.7793 3.83764C12.053 4.08395 12.0752 4.50548 11.8289 4.77915C11.5826 5.05282 11.161 5.07501 10.8874 4.8287L8.02416 2.25182Z",
    fill: "#3787FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.13373cdbb988e29263f712965f77bf36.svg";
export { ForwardRef as ReactComponent };